<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        库存管理
      </div>
    </div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/k1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.houseCount }}</div>
          <div class="a3">仓库总数</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/k2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.stockCount }}</div>
          <div class="a3">当前库存数</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border);"
    >
      <!-- <el-form-item label="选择行政区域">
    <el-select v-model="searchForm.region" placeholder="选择行政区域">
      <el-option label="区域一" value="shanghai"></el-option>
      <el-option label="区域二" value="beijing"></el-option>
    </el-select>
  </el-form-item> -->

      <el-form-item label="输入搜索" prop="name">
        <el-input v-model="houseName" placeholder="请输入仓库名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="chozhi">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width:100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="仓库编号" prop="houseId"> </el-table-column>

      <el-table-column label="仓库名称" prop="houseName"> </el-table-column>

      <el-table-column label="负责人" prop="contactsName"> </el-table-column>

      <el-table-column label="手机号" prop="contactsPhone"> </el-table-column>

      <el-table-column label="地址" prop="address"> </el-table-column>

      <el-table-column label="当前库存数" prop="stockCount"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link type="primary" @click="getchakxq(scope.row.houseId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      arr: "",
      houseName: "",
      tableData: [],
      shanghai: "",
      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  mounted() {
    this.getOperateHouseTotal();

    this.getOperateHouseList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    chozhi() {
      this.houseName = "";
      this.getOperateHouseList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxu() {
      this.getOperateHouseList(this.searlist.curPage, this.searlist.pageSize);
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getOperateHouseList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getOperateHouseList(v, this.searlist.pageSize);
    },

    getOperateHouseList(curr, pagesize) {
      this.$api.activitymsg
        .getOperateHouseList({
          current: curr,
          size: pagesize,
          houseName: this.houseName,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getOperateHouseTotal() {
      this.$api.activitymsg.getOperateHouseTotal({}).then((e) => {
        this.arr = e.data;
      });
    },

    getchakxq(id) {
      this.$router.push({
        path: "orderitem",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.con-let {
  height: 50px;
}

.a7 {
  width: 700px;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
